import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButtonGroup } from '@mylighthouse/prism-ember';
import { CURRENCY_MAPPING } from 'frontend-utils/utils/constants/currency-mapping-constants';
import type { CommissionUnit } from 'lumen/utils/net-revenue/cost/types';

interface SettingsCostUnitToggleSignature {
  Args: {
    onChange: (unit: CommissionUnit) => void;
    unit: CommissionUnit;
  };
}

/**
 * The shared $/% unit toggle for commission inputs. The currency button shows
 * the market's symbol so simple and advanced modes always agree on it.
 */
export default class SettingsCostUnitToggle extends Component<SettingsCostUnitToggleSignature> {
  @service('hotel-and-market')
  declare hotelAndMarket: Services['hotel-and-market'];

  get currencySymbol(): string {
    const { currencyCode } = this.hotelAndMarket.hotelOrMarket;

    return CURRENCY_MAPPING[currencyCode] ?? currencyCode;
  }

  @action handleChange(value: string | string[]): void {
    this.args.onChange(value as CommissionUnit);
  }

  <template>
    <PrismButtonGroup
      @onChange={{this.handleChange}}
      @value={{@unit}}
      as |ButtonGroup|
    >
      <ButtonGroup.button
        @label={{this.currencySymbol}}
        @value="currency"
        data-test-id="cost-unit-currency"
      />
      <ButtonGroup.button
        @label="%"
        @value="percentage"
        data-test-id="cost-unit-percentage"
      />
    </PrismButtonGroup>
  </template>
}
